import { PlayNetworkOutlineIcon } from './PlayNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 951FE34F-7D2E-45FF-8014-FB4EBC49BED1
 * name play-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-network-outline.svg
 * tags
 */
export const MediaNetworkOutlineIcon = PlayNetworkOutlineIcon;
export default MediaNetworkOutlineIcon